import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    icon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
                                         label,
                                         icon,
                                         className = "",
                                         required = false,
                                         ...props
                                     }) => {
    return (
        <div className="mb-5">
            {label && (
                <label className={`st-label ${required ? 'st-label-required' : ''}`}>
                    {label}
                </label>
            )}

            <div className={icon ? "st-input-icon-wrapper" : ""}>
                {icon && (
                    <div className="st-input-icon w-5 h-5 flex items-center justify-center">
                        {icon}
                    </div>
                )}
                <input
                    className={`st-input ${icon ? 'st-input-with-icon' : ''} ${className}`}
                    required={required}
                    {...props}
                />
            </div>
        </div>
    );
};

export default Input;